import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  GetZoomSetting200Response,
  ZoomSettingApi,
  ZoomSettingApiConnectZoomApiRequest,
  ZoomSettingApiUpdateZoomSettingRequest,
} from '@/api/openapi';

export class ZoomSettingApiService extends ApiService {
  api = new ZoomSettingApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getZoomSetting(
    apiArguments?: ApiArguments<undefined>,
  ): Promise<AxiosResponse<GetZoomSetting200Response>> {
    return this.checkResponse<GetZoomSetting200Response>(
      this.api.getZoomSetting(apiArguments?.options),
      apiArguments?.errorHandlers,
    );
  }

  async updateZoomSetting({
    request,
    options,
    errorHandlers,
  }: ApiArguments<ZoomSettingApiUpdateZoomSettingRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(this.api.updateZoomSetting(request, options), errorHandlers);
  }

  async connectZoomApi({
    request,
    options,
    errorHandlers,
  }: ApiArguments<ZoomSettingApiConnectZoomApiRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(this.api.connectZoomApi(request, options), errorHandlers);
  }

  async disconnectZoomApi(
    apiArguments?: ApiArguments<undefined>,
  ): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(this.api.disconnectZoomApi(apiArguments?.options), apiArguments?.errorHandlers);
  }
}
